import { l } from '@manychat/manyui'

export enum FilterOperator {
  AND = 'AND',
  IS = 'IS',
  OR = 'OR',
}

export enum FilterSource {
  TEST = 'test',
  LIVECHAT = 'livechat',
  POST_STATISTICS = 'post_statistics',
  POST_TARGETING = 'post_targeting',
  TRIGGER_RULE = 'trigger_rule',
  AUDIENCE = 'audience',
  FLOWBUILDER_MULTICONDITION = 'flowbuilder_multicondition',
  AUTOASSIGNMENT_SETTINGS = 'autoassignment_settings',
  BUY_BUTTON_CONDITION = 'buy_button_condition',
  USER_FIELD_EVENT_FILTER = 'user_field_event_filter',
}

export enum FilterScenario {
  CONDITION_NODE = 'condition_node',
  LIVECHAT = 'livechat',
  AUTO_ASSIGN = 'auto_assign',
  IMPORT_CONTACTS = 'import_contacts',
  EXTERNAL_REQUESTS = 'external_requests',
  GOOGLE_SHEETS = 'google_sheets',
  CONTACTS = 'contacts',
  LABELS = 'labels',
}

export const GLOBAL_OPERATORS = [
  { value: FilterOperator.AND, label: l.makeTranslate('all of the following conditions') },
  { value: FilterOperator.OR, label: l.makeTranslate('any of the following conditions') },
]
